import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import * as api from "../../constants/api_constants";

import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import { post } from "helpers/api_helper";

function AddTicket() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [fetchedData, setFetchedData] = useState({});

  const validationSchema = Yup.object({
    subject: Yup.string().required("Subject is required"),
    category: Yup.string().required("Category is required"),
    description: Yup.string().required("Description is required"),
    priority: Yup.string().required("Priority is required"),
    status: Yup.string(),
    assign: Yup.string(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subject: "",
      assigncategory: "",
      description: "",
      priority: "",
      attachment: "",
      status: "Open",
      assign: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const payload = {
        title: values.subject,
        description: values.description,
        category: values.category,
        ticketStatus: values.status,
        priority: values.priority,
        assigned: values.assign,
      };
      try {
        const response = await post(api.CREATE_TICKET, payload);
        debugger;
        if (response) {
          showSuccessToast("Ticket created successfully");
          navigate("/tickets");
        }
      } catch (error) {
        showErrorToast("Failed to create ticket");
      }
    },
  });

  const heading = id ? "Update" : "Create";

  return (
    <div className="page-content">
      <Container fluid={true} className="py-0 px-0">
        <PageSubHeader
          heading={`${heading} Ticket`}
          routePath={"Home"}
          pageName={`${heading} Ticket`}
        />

        <Row className="px-4 mx-0 my-3 ">
          <Col className="p-0 m-0" xs={12} md={12}>
            <Card>
              <CardBody>
                {/* <h4 className="card-title text-primary">Add Employee</h4> */}
                <Form className="row g-3 needs-validation py-3" onSubmit>
                  <Row className="card-group">
                    <Col xs={12} className="card-header">
                      <p className="form-header">Ticket Information</p>
                    </Col>
                    <Row className="card-group-body">
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="subject">
                            Subject
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="subject"
                            type="text"
                            className="form-control"
                            id="subject"
                            value={formik.values.subject || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.subject && formik.errors.subject
                                ? true
                                : false
                            }
                          ></Input>
                          {formik.touched.subject && formik.errors.subject ? (
                            <FormFeedback type="invalid">
                              {formik.errors.subject}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      {/* <Col md={2}></Col> */}
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="category">
                            Category
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="category"
                            type="select"
                            className="form-control"
                            id="category"
                            value={formik.values.category || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.category && formik.errors.category
                                ? true
                                : false
                            }
                          >
                            <option value="">Select Type</option>
                            <option value="APPLICATION TOOLS">
                              Application Tools
                            </option>
                            <option value="CODING">Coding</option>
                            <option value="HARDWARE">Hardware</option>
                            <option value="INFRASTRUCTURE">
                              Infrastructure
                            </option>
                            <option value="OTHERS">Others</option>
                            <option value="SOFTWARE">Software</option>
                          </Input>
                          {formik.touched.category && formik.errors.category ? (
                            <FormFeedback type="invalid">
                              {formik.errors.category}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="priority">
                            Priority
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="priority"
                            type="select"
                            className="form-control"
                            id="priority"
                            value={formik.values.priority || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.priority && formik.errors.priority
                                ? true
                                : false
                            }
                          >
                            <option value="">Select</option>
                            <option value="LOW">Low</option>
                            <option value="MEDIUM">Medium</option>
                            <option value="HIGH">High</option>
                          </Input>
                          {formik.touched.priority && formik.errors.priority ? (
                            <FormFeedback type="invalid">
                              {formik.errors.priority}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="assign">
                            Assign
                            <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="assign"
                            type="select"
                            className="form-control"
                            id="assign"
                            value={formik.values.assign || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.assign && formik.errors.assign
                                ? true
                                : false
                            }
                          >
                            <option value="">Select Name</option>
                            <option value="APPLICATION TOOLS">
                              Gopi
                            </option>
                            <option value="CODING">Giri</option>
                            <option value="HARDWARE">Pavan</option>
                            <option value="INFRASTRUCTURE">
                              Vamshi
                            </option>
                            <option value="OTHERS">Kowshik</option>
                            <option value="SOFTWARE">Shad</option>
                          </Input>
                          {formik.touched.assign && formik.errors.assign ? (
                            <FormFeedback type="invalid">
                              {formik.errors.assign}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="description">
                            Description <span className="text-danger"> *</span>
                          </Label>
                          <Input
                            name="description"
                            type="textarea"
                            className="form-control"
                            id="description"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.description &&
                              formik.errors.description
                                ? true
                                : false
                            }
                            value={formik.values.description || ""}
                          />
                          {formik.touched.description &&
                          formik.errors.description ? (
                            <FormFeedback type="invalid">
                              {formik.errors.description}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="attachment">Attachment</Label>
                          <Input
                            name="attachment"
                            type="file"
                            className="form-control"
                            id="attachment"
                            //value={formik.values.attachment || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.attachment &&
                              formik.errors.attachment
                                ? true
                                : false
                            }
                          />
                          {formik.touched.attachment &&
                          formik.errors.attachment ? (
                            <FormFeedback type="invalid">
                              {formik.errors.attachment}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col xs={12} md={6}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="status">Status</Label>
                          <Input
                            name="status"
                            type="select"
                            className="form-control"
                            id="status"
                            value={formik.values.status || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.status && formik.errors.status
                                ? true
                                : false
                            }
                          >
                            <option value="">Select</option>
                            <option value="OPEN">Open</option>
                            <option value="IN_PROGRESS">In Progress</option>
                            <option value="ASSIGNED">Assigned</option>
                            <option value="RESOLVED">Resolved</option>
                            <option value="REOPEN">Reopen</option>
                            <option value="ESCALATED">Escalated</option>
                            <option value="CLOSED">Closed</option>
                            <option value="DUPLICATE">Duplicate</option>
                            <option value="INVALID">Invalid</option>
                          </Input>
                          {formik.touched.status && formik.errors.status ? (
                            <FormFeedback type="invalid">
                              {formik.errors.status}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer save={formik.handleSubmit} />
    </div>
  );
}

export default AddTicket;